import {
    UPDATE_PROFILE_DETAILS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PROFILE_DETAILS:
            return {
                ...state,
                SUBMIT_loading: false,
                status: action.updateProfileDetails,
                actionType: action.actionType,
            }
        default:
            return state
    }
}